import React, { useState, useEffect, useMemo, useRef } from "react"
import { Container, Row, Col } from "react-bootstrap"
import DataTable from "react-data-table-component"
import CompanySelector from "ATSComponents/Common/CompanySelector"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"
import axios from "axios"
import Select from "react-select";
import Swal from "sweetalert2";
const getTodayDate = () => {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, "0")
  const day = String(today.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}
const customStyles = {
  headCells: {
    style: {
      fontSize: "14px",
      fontWeight: "bold",
    },
  },
  cells: {
    style: {
      fontSize: "12px",
    },
  },
}
const audioCache = {};
const getRecordingPlayUrl = (url) => {
  if (!url) return null;

  return `/api/v1/play-recording/?url=${encodeURIComponent(
    url
  )}`;
};

const formatDateTime = dateStr => {
  if (!dateStr) return "-"

  const d = new Date(dateStr)

  const day = String(d.getDate()).padStart(2, "0")
  const month = String(d.getMonth() + 1).padStart(2, "0")
  const year = d.getFullYear()

  let hours = d.getHours()
  const minutes = String(d.getMinutes()).padStart(2, "0")
  const seconds = String(d.getSeconds()).padStart(2, "0")

  const ampm = hours >= 12 ? "PM" : "AM"

  hours = hours % 12
  hours = hours ? hours : 12 // 0 becomes 12

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`
}

const formatStatusLabel = value => {
  if (!value) return "-"
  const text = String(value).trim()
  return text.charAt(0).toUpperCase() + text.slice(1)
}

const CustomLoader = () => (
  <OrgTableShimmer columns={6} rows={6} titleWidth="220px" />
)

const paginationComponentOptions = {
  selectAllRowsItem: true,
  selectAllRowsItemText: "All",
}
const RecordingPlayer = ({ src, currentPlayingRef }) => {
  const [audioSrc, setAudioSrc] = useState(audioCache[src] || null);
  const [loading, setLoading] = useState(!audioCache[src]);
  const [error, setError] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (!src) return;

    // Cached
    if (audioCache[src]) {
      setAudioSrc(audioCache[src]);
      setLoading(false);
      return;
    }

    const fetchAudio = async () => {
      try {
        const response = await axios.get(src, { responseType: "blob" });

        if (!response.data || response.data.size < 500) {
          setError(true);
          return;
        }

        const blobUrl = URL.createObjectURL(response.data);
        audioCache[src] = blobUrl;

        setAudioSrc(blobUrl);
      } catch (error) {
        console.error("Audio fetch failed:", error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchAudio();
  }, [src]);

  const handlePlay = () => {
    if (currentPlayingRef.current && currentPlayingRef.current !== audioRef.current) {
      currentPlayingRef.current.pause();
    }
    currentPlayingRef.current = audioRef.current;
  };

  if (error) {
    return (
      <div
        style={{
          width: 250,
          color: "blac",
          fontSize: "12px",
          textAlign: "center",
          fontWeight: "bold",
          padding: "10px 0",
        }}
      >
        Record Not Found
      </div>
    );
  }

  return (
    <div style={{ width: 250 }}>
      {loading && (
        <div style={{ padding: "10px 0", textAlign: "center", fontSize: "12px", color: "#555" }}>
          ⏳ Loading audio...
        </div>
      )}

      {audioSrc && (
        <audio
          ref={audioRef}
          controls
          preload="metadata"
          onPlay={handlePlay}
          style={{ width: "100%", display: loading ? "none" : "block" }}
          src={audioSrc}
        />
      )}
    </div>
  );
};

function ExtensionLogs() {
  document.title = "ATS - Extension Logs";
  const [companyId, setCompanyId] = useState(null)
  const [logs, setLogs] = useState([])
  const [page, setPage] = useState(1)
  const [totalRows, setTotalRows] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [loading, setLoading] = useState(false)
  const [startDate, setStartDate] = useState(getTodayDate())
  const [endDate, setEndDate] = useState(getTodayDate())
  const [extensionName, setExtensionName] = useState("")
  const [contacts, setContacts] = useState([]);
  const [loadingContacts, setLoadingContacts] = useState(false);
  const [selectedRecruiters, setSelectedRecruiters] = useState([]);
  const [callStatus, setCallStatus] = useState({
  value: "ANSWERED",
  label: "ANSWERED",
});
const callStatusOptions = [
  { value: "ANSWERED", label: "ANSWERED" },
  { value: "NO ANSWER", label: "NO ANSWER" },
  { value: "initiated", label: "Initiated" },
  { value: "all", label: "All" },
];
const fetchContacts = async () => {
  if (!companyId) return;

  setLoadingContacts(true);

  try {
    const response = await axios.get(
      "/api/v1/company-recruiters/",
      // {
      //   // params: { company_id: companyId },
      // }
    );

    const list = response.data?.data || [];

    const mapped = list.map(r => ({
      value: r.id,
      label: r.name,
      fullName: r.name,
      role: r.role
    }));

    setContacts(mapped);
    if (mapped.length === 1) {
      setSelectedRecruiters(mapped[0]);
    }
  } catch (error) {
    console.error("Recruiter API Error:", error);
    setContacts([]);
  } finally {
    setLoadingContacts(false);
  }
};
useEffect(() => {
  if (companyId) {
    fetchContacts();
  }
}, [companyId]);


  const handleCompanyChange = c => {
    if (c?.company_id) setCompanyId(c.company_id)
  }

  const handleStartDateChange = e => {
    const nextStartDate = e.target.value
    setStartDate(nextStartDate)

    if (endDate && nextStartDate && endDate < nextStartDate) {
      setEndDate("")
    }
  }

  const handleEndDateChange = e => {
    const nextEndDate = e.target.value

    if (startDate && nextEndDate && nextEndDate < startDate) {
      setEndDate("")
      return
    }

    setEndDate(nextEndDate)
  }

  const fetchCallLogs = async (pageNumber = 1, rows = perPage) => {
  if (!startDate || !endDate) {
    setLogs([])
    setTotalRows(0)
    setPage(1)
    return
  }

  try {
    setLoading(true);

    const recruiterId = selectedRecruiters?.value || "";

    const { data } = await axios.get("api/v1/extension-call-records/", {
      params: {
        startdate: startDate,
        enddate: endDate,
        page: pageNumber,
        size: rows,
        recruiter_id: recruiterId,
        call_status: callStatus?.value,
        company_id: companyId
      },
    });

    if (data?.data) {
      const results = data.data.results || [];

      setLogs(results);
      setTotalRows(data.data.count || 0);
      setPage(pageNumber);
    }
  } catch (error) {
    console.error("Error fetching call logs:", error);

    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to fetch call logs. Please try again.",
    });
  } finally {
    setLoading(false);
  }
};
  const handlePageChange = page => {
    fetchCallLogs(page)
  }

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage)
    fetchCallLogs(page, newPerPage)
  }
  const currentPlayingRef = useRef(null);

  const columns = [
    {
      name: "Recruiter Name",
      selector: row => (
        <span title={row.extname || "-"}>{row.extname || "-"}</span>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Extension",
      selector: row => (
        <span title={row.extension || "-"}>{row.extension || "-"}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Job Title",
      selector: row => (
        <span title={row.job_title || "-"}>
          {row.job_title || "-"}
        </span>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Candidate Name",
      selector: row => (
        <span title={row.candidate_name || "-"}>
          {row.candidate_name || "-"}
        </span>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Candidate Phone Number",
      selector: row => <span title={row.dst || "-"}>{row.dst || "-"}</span>,
      sortable: true,
      width: "245px",
    },
    {
      name: "Call Date",
      selector: row => {
        const date = formatDateTime(row.calldate)
        return <span title={date}>{date}</span>
      },
      sortable: true,
      width: "200px",
    },
    {
      name: "Call Status",
      selector: row => (
        <span title={formatStatusLabel(row.disposition)}>{formatStatusLabel(row.disposition)}</span>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Disposition",
      selector: row => (
        <span title={formatStatusLabel(row.callstatus)}>{formatStatusLabel(row.callstatus)}</span>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Duration (sec)",
      selector: row => (
        <span title={row.billsec || "-"}>{row.billsec || "-"}</span>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Recordings",
      cell: row => {
        if (!row.recording_url) return "-";
        const finalUrl = getRecordingPlayUrl(row.recording_url);
        return (
          <RecordingPlayer
            src={finalUrl}
            currentPlayingRef={currentPlayingRef}
          />
        );
      }
    }
  ]

  useEffect(() => {
    if (!companyId) return
    setPage(1)
    fetchCallLogs(1)
  }, [startDate, endDate, companyId,selectedRecruiters,callStatus])

  return (
    <div className="page-content allact-tabs">
      <Container fluid>
        <div className="page-title-box actjobbread mb-0 p-3">
          <Row className="align-items-center actjobsum">
            <Col xxl={6}>
              <h1 className="page-title">Extension Logs</h1>
            </Col>
            <Col xxl={6} className="d-flex justify-content-end">
              <div>
                <label className="me-2 mb-0">Select Company</label>
                <div style={{ width: 170 }}>
                  <CompanySelector onCompanyChange={handleCompanyChange} />
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <Row className="mb-3">
          <Col md={3}>
            <label className="form-label fw-bold">Recruiter(s)</label>
            
            <Select
              // isMulti
              isLoading={loadingContacts}
              options={contacts}
              value={selectedRecruiters}
              onChange={(val) => setSelectedRecruiters(val)}
              placeholder="Select Recruiters"
              classNamePrefix="react-select"
            />
              {callStatus?.value === "initiated" && (
                  <strong
                    style={{
                      color: "#000",
                      display: "block",
                      marginTop: "10px",
                      fontSize: "15px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Note : Calls are Initiated. Recordings will be available after some time.
                  </strong>
                )}
          </Col>
          <Col md={3} className="mb-2">
            <label className="form-label fw-bold">Start Date</label>
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={handleStartDateChange}
            />
          </Col>

          <Col md={3}>
            <label className="form-label fw-bold">End Date</label>
            <input
              type="date"
              className="form-control"
              value={endDate}
              onChange={handleEndDateChange}
            />
          </Col>
          <Col md={2}>
              <label className="form-label fw-bold">Call Status</label>

              <Select
                options={callStatusOptions}
                value={callStatus}
                onChange={(val) => setCallStatus(val)}
                placeholder="Select Call Status"
                classNamePrefix="react-select"
              />
            </Col>
          <Col md={1} className="">
            <div className="invisible">t</div>
            <div className="">
              <button
                className="btn btn-primary blueBtn"
                onClick={() => {
                  const today = getTodayDate()
                  setStartDate(today)
                  setEndDate(today)
                  setExtensionName("");
                  setSelectedRecruiters(null);  
                  setPage(1);
                  fetchCallLogs(1);
                }}
              >
                Clear
              </button>
            </div>
          </Col>
        </Row>
        <Row className="mt-0">
          <Col>
            <div className="card p-2" id="ExtensionLogs_Datatable">
              <DataTable
                columns={columns}
                data={logs}
                pagination
                customStyles={customStyles}
                paginationServer
                paginationTotalRows={totalRows}
                paginationPerPage={perPage}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                highlightOnHover
                striped
                responsive
                paginationComponentOptions={paginationComponentOptions}
                persistTableHead
                fixedHeader
                fixedHeaderScrollHeight="500px"
                progressPending={loading}
                progressComponent={<CustomLoader />}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
export default ExtensionLogs
